export default {
    workOrder_customerTab_name: "Name",
    workOrder_customerTab_eIn: "EIN",
    workOrder_customerTab_contact: "Contact",
    workOrder_customerTab_email: "Email",
    workOrder_customerTab_phone: "Phone",
    workOrder_customerTab_address: "Address",
    workOrder_customerTab_driver: "Driver",
    workOrder_customerTab_createContact: "Create Contact",
    workOrder_customerTab_createLocation: "Create Location",
    workOrder_customerTab_importFinished: "Import Finished",
    workOrder_customerTab_seeSummary: "To see the summary click here",
    workOrder_customerTab_importCustomers: "Import Customers",
};